/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductPlanTier, UserService } from '../../services/user.service';
import { AppsService } from '../../services/apps.service';
import { XdaStringsService } from '../../services/xda-strings.service';

@Component({
  selector: 'remaining-credits-modal-component',
  templateUrl: './remaining-credits-modal.component.html',
  styleUrls: ['./remaining-credits-modal.component.less'],
  standalone: false,
})
export class RemainingCreditsModalComponent implements OnInit {
  creditsLabel: any;
  exampleLabel: any;
  protectString: string;
  mergeString: string;
  automateString: string;
  creditsString: any;
  units: any;
  loading = true;
  isAdvancedPlan = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private appsService: AppsService,
    private xdaStringsService: XdaStringsService,
  ) {}

  ngOnInit() {
    this.updateUnits();

    const workflow =
      this.xdaStringsService.strings['SQD_MERGE_TRANSLATE_AUDIO'];

    this.protectString = this.xdaStringsService.strings[
      'SDE_CHARGED_FMTSTR_CREDITS'
    ].replace('{0}', '3');
    this.mergeString = this.xdaStringsService.strings[
      'SDE_CHARGE_FMTSTR_CREDITS'
    ].replace('{0}', '2');
    this.automateString =
      this.xdaStringsService.strings['SDE_VARIABLE_CREDIT_CHARGES1'];
    this.isAdvancedPlan =
      (this.userService?.user?.acquisition?.productPlanTier &&
        this.userService.user.acquisition.productPlanTier >=
          ProductPlanTier.Advanced) ||
      false;
    if (this.isAdvancedPlan) {
      this.creditsLabel = this.xdaStringsService.strings[
        'SDE_SINGLE_SERVICE_WORKFLOWS'
      ]
        .replace('{0}', '1')
        .replace('{1}', '')
        .replace('{2}', '1')
        .replace('{3}', '');
      this.exampleLabel = this.xdaStringsService.strings[
        'SDE_FMTSTR_WORKFLOW_TWO'
      ]
        .replace('{0}', workflow)
        .replace('{1}', '3')
        .replace('{2}', '8');
    } else {
      this.creditsLabel = this.xdaStringsService.strings[
        'SDE_WORKFLOWS_USE_FMTSTR'
      ]
        .replace('{0}', '1')
        .replace('{1}', '');
    }
  }

  async updateUnits() {
    if (this.userService?.user?.id) {
      await this.appsService.getActiveAcquisitions(this.userService.user.id);
      if (this.userService.user.acquisition) {
        // show remaining credits unless unlimited subscription show credits used.
        this.creditsString =
          this.userService.user.acquisition.usage.unitsPurchased !== -1
            ? this.xdaStringsService.strings['SDE_REMAINING_CREDITS']
            : this.xdaStringsService.strings['SDE_TOTAL_CREDITS_USED'];
        this.units =
          this.userService.user.acquisition.usage.unitsPurchased !== -1
            ? this.userService.user.acquisition.usage.unitsRemaining
            : this.userService.user.acquisition.usage.unitsUsed;
      } else {
        this.userService.logOff();
      }
    }

    this.loading = false;
  }
}
